import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
	
	$stateProvider.states(['company.sharing-center.shared-passwords.manage', 'company.sharing-center.shared-authenticators.manage','company.sharing-center.shared-notes.manage'], {
		url: '/manage/:sharedAccountId',
		params: { sharedAccount: {}, convert2fa: false, isNote:false },
		//component: 'companySharingCenterShare',
		redirectTo: '.edit',
		views: {
			'@company.sharing-center': 'companySharingCenterManage'
		},
		resolve: {isNote,sharedAccount,sharedAccountId,convert2fa },
	});
}



/** @ngInject */
function sharedAccountId($stateParams){
	return $stateParams.sharedAccountId;
}

/** @ngInject */
function sharedAccount($stateParams, SharedAccountsService, isNote, sharedAccountId) {
	if (Object.keys($stateParams.sharedAccount).length != 0) {
		return $stateParams.sharedAccount;
	} else {
		const companyId = $stateParams.companyId;
		const id = sharedAccountId;
		if(isNote){
			return SharedAccountsService
			.getNote({ companyId, id }, {}).$promise;
		} else {
			return SharedAccountsService
			.getOneById({ companyId, id }, {}).$promise;
		}
	}
}

/** @ngInject */
function convert2fa($stateParams){
	return $stateParams.convert2fa;
}

/** @ngInject */
function isNote($location, $stateParams){
	var currentUrl=$location.absUrl();;
	return currentUrl.includes('shared-notes') || $stateParams.isNote;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-inner-menu/shared-inner-menu.state.js